import { render, staticRenderFns } from "./NewInspTaskInfo.vue?vue&type=template&id=eb845bfe&scoped=true&"
import script from "./NewInspTaskInfo.vue?vue&type=script&lang=js&"
export * from "./NewInspTaskInfo.vue?vue&type=script&lang=js&"
import style0 from "./NewInspTaskInfo.vue?vue&type=style&index=0&id=eb845bfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb845bfe",
  null
  
)

export default component.exports